export const CountdownTimer = ({ days, hours, minutes, seconds }) => (
  <div className="grid grid-cols-4 gap-x-1 lg:gap-x-4 mb-4">
    {[
      { value: days, label: "DAYS" },
      { value: hours, label: "HOURS" },
      { value: minutes, label: "MINUTES" },
      { value: seconds, label: "SECONDS" },
    ]?.map(({ value, label }) => (
      <div
        key={label}
        className="bg-primary text-white px-4 py-2 text-center rounded"
      >
        <div className="text-xl font-bold">{value}</div>
        <div className="text-xs">{label}</div>
      </div>
    ))}
  </div>
);
